export default __webpack_public_path__ + "static/media/Boots of a Thousand Blossoms.305d0186.jpg";